import { render, staticRenderFns } from "./ProjExpense.vue?vue&type=template&id=75082984&scoped=true"
import script from "./ProjExpense.vue?vue&type=script&lang=js"
export * from "./ProjExpense.vue?vue&type=script&lang=js"
import style0 from "./ProjExpense.vue?vue&type=style&index=0&id=75082984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75082984",
  null
  
)

export default component.exports